import { IContractCard } from 'types/contract/IContractCard';

export const filterContractsByDate = (contracts: IContractCard[], currentDate: Date) => {
  const dateYear = currentDate.getFullYear();
  const dateMonth = currentDate.getMonth();
  const dateDay = currentDate.getDate();
  const filterdContracts = contracts.filter(card => {
    const contractDate = new Date(card.date);
    return (
      dateYear === contractDate.getFullYear() &&
      dateMonth === contractDate.getMonth() &&
      dateDay === contractDate.getDate()
    );
  });
  return filterdContracts;
};

export const generateDate = (date: string, type: string) => {
  const auxArr = date.split(' ');
  if (type === 'start') return `${auxArr[0]}`;
  return `${auxArr[2]} ${auxArr[1]}`;
};

export const getAdjacentDay = (date: Date, day: number) => {
  const auxDate = new Date(date);
  auxDate.setDate(auxDate.getDate() + day);
  return auxDate;
};
